import { render, staticRenderFns } from "./AdSpacesPlaylist.vue?vue&type=template&id=0c8468a6&scoped=true&"
import script from "./AdSpacesPlaylist.vue?vue&type=script&lang=ts&"
export * from "./AdSpacesPlaylist.vue?vue&type=script&lang=ts&"
import style0 from "./AdSpacesPlaylist.vue?vue&type=style&index=0&id=0c8468a6&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c8468a6",
  null
  
)

export default component.exports